/**
 * app > store > cm
 *     > securityPolicy > network
 *     > protectionDomainObject 보호 도메인 객체
 *
 * @created_at 2021-09-01
 * @created_by wj_tams_dev06
 */

import {
  // ObjectSecProfileApiPrefix as objApiPrefix,
  CmApiPrefix
} from 'utils'

const urlPrefix = `${CmApiPrefix}/objects/ips`

export const state = () => ({
  ipVersion: 4,
  objData: {
    host: [],
    network: [],
    group: []
  },
  hostData: {
    addr_obj_type: 1,
    addr_obj_uname: '',
    addr_obj_zone_type: 1,
    addr_obj_ip_start_ip: '',
    addr_obj_ip_end_ip: '',
    addr_obj_ip_exp: '',
    addr_obj_desc: '',
    cfg_layer: 1
  },
  networkData: {
    addr_obj_type: 2,
    addr_obj_uname: '',
    addr_obj_zone_type: 1,
    addr_obj_ip_start_ip: '',
    addr_obj_ip_end_ip: '',
    addr_obj_ip_mask: '',
    addr_obj_ip_exp: '',
    addr_obj_desc: '',
    cfg_layer: 1
  },
  groupData: {
    addr_obj_type: 4,
    addr_obj_id: 1,
    addr_obj_uname: '',
    mmbr_obj: [],
    addr_obj_desc: '',

    zone: 1,
    desc: ''
  },
  selectedSubData: void 0
})

export const mutations = {
  setIpVersion (state, payload) {
    state.ipVersion = payload
  },
  selectGroupSubData (state, payload) {
    state.selectedSubData = payload
  },
  initAddrForm (state) {
    state.objData = {
      host: [],
      network: [],
      group: []
    }
  },
  updateAddrForm (state, payload) {
    state[payload.target][payload.key] = payload.val
  },
  clearData (state, payload) {
    if (!_.get(state, payload.target)) return
    Object.keys(state[payload.target]).forEach(key => {
      const val = state[payload.target][key]
      if (key === 'addr_obj_ip_mask') {
        state[payload.target][key] = ''
      }
      if (typeof val === 'string') {
        state[payload.target][key] = ''
      } else if (typeof val === 'number') {
        if (key === 'addr_obj_zone_type') {
          state[payload.target][key] = _.get(payload, 'zone') || 1
        } else if (key === 'addr_obj_type') {
          payload.target === 'networkData'
            ? state[payload.target][key] = 2
            : state[payload.target][key] = 4
        }
      } else if (Array.isArray(val)) {
        state[payload.target][key] = []
      } else if (typeof val === 'object') {
        Object.keys(val).forEach(childKey => {
          val[childKey] = null
        })
      } else {
        state[payload.target][key] = void 0
      }
    })
    return true
  }
}

export const actions = {
  async fetchIpsObj ({commit, state}, payload) {
    let url = ''
    const ipType = state.ipVersion === 4 ? '1' : '2'

    const objType = {
      host: '1',
      network: '2',
      group: '4'
    }
    url = `${urlPrefix}/${payload.url}?addr_obj_ip_ver_type=${ipType}&addr_obj_type_list=[${objType[payload.tab]}]`

    const {code, result} = await this.$axios.$get(url, {
      loading: false,
      isNotAlert: true
    })

    if (code === 'ok') {
      commit('initAddrForm')
      commit('updateAddrForm', {target: 'objData', val: result, key: payload.tab})
    }
    return result
  },
  async fetchGroupObjChildren ({commit, state}) {
    const id = state.selectedSubData.addr_obj_id
    const {code, result} = await this.$axios.$get(`${urlPrefix}/addr-grp/${id}`, {
      loading: false,
      successAlert: false
    })
    if (code === 'ok') {
      return result
    }
    return []
  },
  async updateHostNetworkObj ({commit, state}, payload) {
    const data = {
      addr_obj_uname: state[payload.target].addr_obj_uname,
      addr_obj_type: payload.target === 'hostData' ? 1 : 2,
      addr_obj_ip_ver_type: state.ipVersion === 4 ? 1 : 2,
      addr_obj_ip_start_ip: state[payload.target].addr_obj_ip_start_ip,
      force_yn: payload.forceYn
    }

    if (_.get(state[payload.target], 'addr_obj_desc')) {
      data.addr_obj_desc = state[payload.target].addr_obj_desc
    }
    if (payload.target === 'networkData') {
      data.addr_obj_ip_mask = state[payload.target].addr_obj_ip_mask
    }
    const {code, result} = await this.$axios.$post(`${urlPrefix}/addr`, data)

    if (code === 'ok') {
      data.addr_obj_id = result.addr_obj_id
      return data
    } else if (code === '32010332') {
      result.code = code
    }
    return result
  },
  async updateSingleGroup ({commit, state}, payload) {
    /*
      addr_obj_ip_ver_type: (Define=1,2),
      addr_obj_desc: (string)(range=0-128) IPS 주소 객체 설명 (범위: 1 ~ 128)
      mmbr_obj_list: (list-integer) 그룹객체(4)의 속한 주소 객체(addr_pobj_type: [1,2,3,4]) ID 리스트
     */
    const data = {
      addr_obj_uname: payload.addr_obj_uname,
      addr_obj_ip_ver_type: state.ipVersion === 4 ? 1 : 2,
      addr_obj_desc: payload.addr_obj_desc,
      mmbr_obj_list: payload.mmbr_obj_list
    }

    const {code, result} = await this.$axios.$post(`${urlPrefix}/addr-grp`, data)

    if (code === 'ok') {
      return true
    }
    return result
  },
  async addUserInputObj ({commit, state}, payload) {
    const data = {
      addr_obj_ip_ver_type: state.ipVersion === 4 ? 1 : 2,
      addr_obj_ip: payload.ip,
      addr_obj_desc: payload.menuName,
      force_yn: payload.forceYn
    }
    const {code, result} = await this.$axios.$post(`${urlPrefix}/addr-auto`, data)
    if (code === 'ok') {
      data.addr_obj_type = result.addr_obj_type
      data.addr_obj_ip_ver_type = result.addr_obj_ip_ver_type
      data.addr_obj_uname = result.addr_obj_uname
      data.addr_obj_ip_start_ip = result.addr_obj_ip_start_ip
      data.addr_obj_ip_mask = result.addr_obj_ip_mask
      data.addr_obj_id = result.addr_obj_id
      data.addr_obj_desc = result.addr_obj_desc
      /** update objData['host'] (network, group data cannot be directly added with ip address) */
      return data
    } else if (code === '32010332') {
      result.code = '32010332'
    }
    return result
  }
}

export const getters = {}

export const strict = false
